module.exports = __webpack_public_path__ + "img/fr.4e3ec048.svg";